import Nullstack from 'nullstack';
export default function IconBrandCodepen({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-codepen",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 15l9 6l9 -6l-9 -6l-9 6"
  }), "   ", Nullstack.element("path", {
    d: "M3 9l9 6l9 -6l-9 -6l-9 6"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "9",
    x2: "3",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "9",
    x2: "21",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "21"
  }), " ");
}